import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../../components/Table";
import UsTaxItem from "./UsTaxItem";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import {LIST_US_TAX_SETTINGS, ON_US_TAX_SETTINGS_UPDATED} from "../../../queries/sales";

class UsTaxesList extends Component {

  componentDidMount() {
    this.props.subscribeToUpdates(this.props, {});
  }

  render() {
    let {loading, error, usTaxSettings} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let tableHeader = List([
      "Code",
      "Name",
      "Deduct Shipping Cost"
    ])
    return (
      <Table 
        data={fromJS(usTaxSettings)} 
        renderer={UsTaxItem} 
        tableHeader={tableHeader}
        onItemClick={this.handleItemClick.bind(this)}
        selected={this.props.selectedId}
        mode="table"
        itemKey="stateCode"
        />
    )
  }

  handleItemClick(itemData, e, field) {
    this.props.onSelectionChange(itemData);
  }  
}

const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_US_TAX_SETTINGS_UPDATED,
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

const withSubscription = connect(null, mapDispatchToProps);


const withQuery = graphql(LIST_US_TAX_SETTINGS, {
  options: (props) => ({
    fetchPolicy: "network-only"
  })
})

export default withQuery(withSubscription(UsTaxesList));